import {
  createLookupCombiner,
  createLookupSelectors,
  objectMapper,
} from "./lib";
import { selectBusinessRelationIdsByBusinessIdLookup } from "./indexes";
import { getBusinessRelations } from "./root";

export const getBusinessRelationById = relationId => state =>
  getBusinessRelations(state)[relationId] || null;

export const [
  selectBusinessRelationsByBusinessIdLookup,
  getBusinessRelationsByBusinessId,
] = createLookupSelectors(
  [selectBusinessRelationIdsByBusinessIdLookup, getBusinessRelations],
  createLookupCombiner(objectMapper),
);
